<script setup lang="ts">
import {ref} from "vue";
import {useI18n} from "vue-i18n";
import AccountSettings from "@/components/AccountSettings/AccountSettings.vue";
import PersonalInfo from "@/components/PersonalInfo/PersonalInfo.vue";

const tab = ref('info');


const { t } = useI18n();
</script>

<template>
    <div class="bg-primary-account flex flex-col justify-between min-h-36">
      <div class="bottom mt-8">
            <h1 class="container responsive-title-3 font-semibold py-8 header">{{ t('myAccount.title') }}</h1>
            <ElTabs v-model="tab" @tab-change="(newTab) => { tab = newTab }" class="headerf">
              <div class="mt-6 mb-6 container">
                <ElTabPane :label="t('myAccount.tabs.personalInfo')" name="info" >
                    <PersonalInfo />
                </ElTabPane>
<!--                <ElTabPane :label="t('myAccount.tabs.paymentMethods')" name="payment" class="px-12 mainPanel">-->
<!--                    <PaymentMethods />-->
<!--                </ElTabPane>-->
<!--                <ElTabPane :label="t('myAccount.tabs.billing')" name="billing" class="px-12 mainPanel">-->
<!--                    <Billing />-->
<!--                </ElTabPane>-->
                <ElTabPane :label="t('myAccount.tabs.accountSettings')" name="settings" >
                    <AccountSettings />
                </ElTabPane>
              </div>
            </ElTabs>
        </div>
    </div>
</template>

<style scoped>
.border-black {
    border-color: black !important;
}

:deep(.el-tabs__nav-wrap:after) {
    background-color: transparent !important;
}

:deep(.el-tabs__content) {
    padding: 0;
    background-color: #FFF;
    width: 100%;
}

:deep(.el-tabs__item:hover),

:deep(.el-tabs__item.is-active) {
    color: black;
    border: black;
}

:deep(.el-tabs__item.is-active) {
    color: black;
    font-weight: 600;
}

:deep(.el-tabs__item:not(.is-active)) {
  color: #8C8B94;
  font-weight: 600;
}

:deep(.el-tabs__active-bar) {
    background-color: black;
    height: 3px;
}


@media (max-width: 768px) {
    .mainPanel {
        padding: 0;
    }
  
}
:deep(.el-tabs__header) {
  margin-bottom: 0;
}

</style>
